import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ContactIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ContactIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M14.3516 18.2188H6.3291C6.05273 18.2188 5.8291 17.9951 5.8291 17.7188V16.6064C5.8291 14.6846 7.39258 13.1211 9.31445 13.1211H11.3662C13.2881 13.1211 14.8516 14.6846 14.8516 16.6064V17.7188C14.8516 17.9951 14.6279 18.2188 14.3516 18.2188ZM6.8291 17.2188H13.8516V16.6064C13.8516 15.2358 12.7368 14.1211 11.3662 14.1211H9.31445C7.94384 14.1211 6.8291 15.2358 6.8291 16.6064V17.2188Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.3403 12.1157C8.89502 12.1157 7.71924 10.9399 7.71924 9.49464C7.71924 8.04933 8.89502 6.87306 10.3403 6.87306C11.7856 6.87306 12.9614 8.04933 12.9614 9.49464C12.9614 10.9399 11.7856 12.1157 10.3403 12.1157ZM10.3403 7.87305C9.44629 7.87305 8.71924 8.60059 8.71924 9.49463C8.71924 10.3887 9.44629 11.1157 10.3403 11.1157C11.2344 11.1157 11.9614 10.3887 11.9614 9.49463C11.9614 8.60059 11.2344 7.87305 10.3403 7.87305Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.9346 22H3.74609C2.87695 22 2.16992 21.293 2.16992 20.4238V3.57617C2.16992 2.70703 2.87695 2 3.74609 2H16.9346C17.8037 2 18.5107 2.70703 18.5107 3.57617V20.4238C18.5107 21.293 17.8037 22 16.9346 22ZM3.74609 3C3.42822 3 3.16992 3.2583 3.16992 3.57617V20.4238C3.16992 20.7417 3.42822 21 3.74609 21H16.9346C17.2524 21 17.5107 20.7417 17.5107 20.4238V3.57617C17.5107 3.2583 17.2524 3 16.9346 3H3.74609Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.9663 7.92578C20.6899 7.92578 20.4663 7.70215 20.4663 7.42578V4.75195C20.4663 4.47558 20.6899 4.25195 20.9663 4.25195C21.2427 4.25195 21.4663 4.47558 21.4663 4.75195V7.42578C21.4663 7.70215 21.2427 7.92578 20.9663 7.92578Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.9663 13.2739C20.6899 13.2739 20.4663 13.0503 20.4663 12.7739V10.1001C20.4663 9.82373 20.6899 9.6001 20.9663 9.6001C21.2427 9.6001 21.4663 9.82373 21.4663 10.1001V12.7739C21.4663 13.0503 21.2427 13.2739 20.9663 13.2739Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.9663 18.6221C20.6899 18.6221 20.4663 18.3984 20.4663 18.1221V15.4482C20.4663 15.1719 20.6899 14.9482 20.9663 14.9482C21.2427 14.9482 21.4663 15.1719 21.4663 15.4482V18.1221C21.4663 18.3984 21.2427 18.6221 20.9663 18.6221Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ContactIcon;
